import React from 'react';

const Chapters = () => {
    return (
        <div>hello</div>
    )
}

export default Chapters